// extracted by mini-css-extract-plugin
export default {"flex":"PayOnDelivery_flex__qIBdU","container":"PayOnDelivery_container__GJJ2i"};